package com.eladfinish.bible.contest.screens.search.usecases

import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.search_termination_format
import dev.icerock.moko.resources.StringResource
import dev.icerock.moko.resources.desc.StringDesc
import dev.icerock.moko.resources.desc.desc
import dev.icerock.moko.resources.format

class BuildSearchTerminationMessageUseCase {

    operator fun invoke(
        stringResource: StringResource,
        durationSeconds: Double,
    ): StringDesc =
        SharedRes.strings.search_termination_format.format(
            stringResource.desc(),
            durationSeconds.toString().desc(),
        )
}
